"use strict";

require("core-js/modules/es6.object.define-properties");

require("core-js/modules/es6.object.freeze");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Styled = void 0;

var _styledComponents = require("styled-components");

var _utils = require("../../../utils");

var _flex = require("./flex.inject");

var _getIndentations = require("../../../utils/get-indentations");

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n    ", ";\n    ", ";\n\n    ", ";\n    ", ";\n\n    ", ";\n\n    ", "\n    ", "\n  "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var Flex = (0, _utils.sc)('div')(function (_ref) {
  var $direction = _ref.$direction,
      $margin = _ref.$margin,
      $padding = _ref.$padding,
      isInline = _ref.isInline,
      isReversed = _ref.isReversed,
      isWrap = _ref.isWrap,
      alignment = _ref.alignment;
  return (0, _styledComponents.css)(_templateObject(), _flex.inject.displayStyle({
    isInline: isInline
  }), _flex.inject.width({
    isInline: isInline
  }), _flex.inject.directionStyle({
    direction: $direction,
    isReversed: isReversed
  }), _flex.inject.wrapStyle({
    isWrap: isWrap
  }), (0, _utils.getAlignment)({
    direction: $direction,
    alignment: alignment
  }), (0, _getIndentations.getIndentations)({
    type: 'margin',
    indentObj: $margin
  }), (0, _getIndentations.getIndentations)({
    type: 'padding',
    indentObj: $padding
  }));
})('Flex');
var Styled = {
  Flex: Flex
};
exports.Styled = Styled;